export default "__VITE_ASSET__CBV1veAC__"